export const AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG = "ai_multi_model_provider";
export const MODEL_PROVIDER_ENTITY_KEY = "Model Provider";
